<h1 mat-dialog-title class="text-center">Automatic String Creation</h1>
<div mat-dialog-content class="contentt">
  <div class="entry-forms mt-4">
    <div class="tabledesign">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="s_no">
          <th mat-header-cell *matHeaderCellDef> S.No. </th>
          <td mat-cell *matCellDef="let row">1</td>
        </ng-container>
        <ng-container matColumnDef="string">
            <th mat-header-cell *matHeaderCellDef> String </th>
            <td mat-cell *matCellDef="let row"> 
              <mat-form-field class="field-bottom-0 my-2" appearance="outline" >
                <input type="text" matInput>
              </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef> Type </th>
            <td mat-cell *matCellDef="let row"> 
              <mat-form-field class="field-bottom-0 my-2" appearance="outline">
                <input type="text" matInput>
              </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="operation">
            <th mat-header-cell *matHeaderCellDef> Operation </th>
            <td mat-cell *matCellDef="let row"> 
              <mat-form-field class="field-bottom-0 my-2" appearance="outline" >
                <input type="text" matInput>
              </mat-form-field>
            </td>
        </ng-container>
        <tr mat-header-row  *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: this.displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>
<div mat-dialog-actions>
    <div class="row w-100">
        <div class="col-md-12 text-end">
            <button mat-raised-button color="primary" mat-dialog-close>Save</button>
        </div>
    </div>
</div>